import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { EULA } from 'src/app/models/eula.model';
import { AppSettingsService } from '../app-settings/app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class EulaService {

  constructor(
    private http: HttpClient,
    private settings: AppSettingsService,
  ) { }

  getCurrentEULA(): Observable<EULA> {
    const url = this.settings.apiUrl + `eula/current`;

    return this.http.get(url).pipe(
      map((data: EULA) => {
        return new EULA(data);
      })
    );
  }

  acceptEULA(eulaID: number){
    const url = this.settings.apiUrl + `eula/accept/${eulaID}`;
    return this.http.post(url, {});
  }
}
